export * from "wretch/middlewares";
const CSRF_TOKEN_HEADER = "X-CSRF-Token";
function csrf() {
  let csrfToken = null;
  return (next) => async (url, wretchOptions) => {
    const headers = new Headers(wretchOptions.headers);
    if (csrfToken !== null) {
      headers.set(CSRF_TOKEN_HEADER, csrfToken);
    }
    const response = await next(url, {
      ...wretchOptions,
      headers
    });
    if (response.headers.has(CSRF_TOKEN_HEADER)) {
      csrfToken = response.headers.get(CSRF_TOKEN_HEADER);
    }
    return response;
  };
}
function defaultLogRequest(url, options) {
  console.log(`(REQ) [${options.method}] ${url}`, options);
}
async function defaultLogResponse(response) {
  const headers = response.headers;
  const contentType = headers.get("Content-Type");
  let content;
  if (contentType == null ? void 0 : contentType.includes("application/json")) {
    content = await response.json();
  } else if (contentType == null ? void 0 : contentType.includes("text/")) {
    content = await response.text();
  } else {
    content = response.body;
  }
  console.log(`(RES) [${response.status}] ${response.url}`, content);
}
function debug({
  logRequest,
  logResponse
} = {}) {
  const requestLogger = logRequest ?? defaultLogRequest;
  const responseLogger = logResponse ?? defaultLogResponse;
  return (next) => async (url, wretchOptions) => {
    await requestLogger(url, wretchOptions);
    const response = await next(url, wretchOptions);
    await responseLogger(response.clone());
    return response;
  };
}
function manipulateHeaders(manipulator) {
  return (next) => (url, { headers, ...options }) => {
    const nextHeaders = manipulator(new Headers(headers));
    return next(url, { ...options, headers: nextHeaders });
  };
}
export {
  CSRF_TOKEN_HEADER,
  csrf,
  debug,
  manipulateHeaders
};
//# sourceMappingURL=middleware.js.map
